import loc from 'owa-localize';
import type { RibbonControlId } from 'owa-ribbon-ids';
import { MailRibbonControlId } from 'owa-ribbon-ids';
import Desc from './hoverTooltipDesc.locstring.json';

/**
 * Maps each control to its corresponding description string
 */
const controlDescMap = new Map<RibbonControlId, string>()
    .set(MailRibbonControlId.AddressBook, Desc.addressBookButtonDesc)
    .set(MailRibbonControlId.Archive, Desc.archiveButtonDesc)
    .set(MailRibbonControlId.AssignPolicy, Desc.assignPolicyButtonDesc)
    .set(MailRibbonControlId.Block, Desc.blockButtonDesc)
    .set(MailRibbonControlId.BrowseGroups, Desc.browseGroupsButtonDesc)
    .set(MailRibbonControlId.Categorize, Desc.categorizeButtonDesc)
    .set(MailRibbonControlId.CheckNames, Desc.checkNamesButtonDesc)
    .set(MailRibbonControlId.CreateRule, Desc.createRuleButtonDesc)
    .set(MailRibbonControlId.DeleteItem, Desc.deleteButtonDesc)
    .set(MailRibbonControlId.DiscardDraft, Desc.discardButtonDesc)
    .set(MailRibbonControlId.Emojis, Desc.emojiButtonDesc)
    .set(MailRibbonControlId.Encrypt, Desc.encryptButtonDesc)
    .set(MailRibbonControlId.FlagClearFlag, Desc.flagClearFlagButtonDesc)
    .set(MailRibbonControlId.FlagCompleteNextWeek, Desc.flagNextWeekButtonDesc)
    .set(MailRibbonControlId.FlagCompleteNoDate, Desc.flagNoDateButtonDesc)
    .set(MailRibbonControlId.FlagCompleteThisWeek, Desc.flagThisWeekButtonDesc)
    .set(MailRibbonControlId.FlagCompleteToday, Desc.flagTodayButtonDesc)
    .set(MailRibbonControlId.FlagCompleteTomorrow, Desc.flagTomorrowButtonDesc)
    .set(MailRibbonControlId.FlagMarkComplete, Desc.flagMarkCompleteButtonDesc)
    .set(MailRibbonControlId.FlagUnflag, Desc.flagButtonDesc)
    .set(MailRibbonControlId.GetAddIns, Desc.getAddinsButtonDesc)
    .set(MailRibbonControlId.HighImportance, Desc.highImportanceButtonDesc)
    .set(MailRibbonControlId.IgnoreStopIgnore, Desc.ignoreButtonDesc)
    .set(MailRibbonControlId.ImmersiveReader, Desc.immersiveReaderButtonDesc)
    .set(MailRibbonControlId.JunkFlyout, Desc.junkFlyoutButtonDesc)
    .set(MailRibbonControlId.JunkNotJunk, Desc.junkButtonDesc)
    .set(MailRibbonControlId.LowImportance, Desc.lowImportanceButtonDesc)
    .set(MailRibbonControlId.ManageRules, Desc.manageRulesButtonDesc)
    .set(MailRibbonControlId.Move, Desc.moveButtonDesc)
    .set(MailRibbonControlId.NewMessage, Desc.newMessageButtonDesc)
    .set(MailRibbonControlId.NewMessageSplitButton, Desc.newMessageButtonDesc)
    .set(MailRibbonControlId.Phishing, Desc.phishingButtonDesc)
    .set(MailRibbonControlId.PinUnpin, Desc.pinButtonDesc)
    .set(MailRibbonControlId.Pictures, Desc.picturesButtonDesc)
    .set(MailRibbonControlId.Poll, Desc.pollButtonDesc)
    .set(MailRibbonControlId.ReadAloud, Desc.readAloudButtonDesc)
    .set(MailRibbonControlId.ReadUnread, Desc.readUnreadButtonDesc)
    .set(MailRibbonControlId.RespondForward, Desc.forwardButtonDesc)
    .set(MailRibbonControlId.ReplyWithMeeting, Desc.replyWithMeetingButtonDesc)
    .set(MailRibbonControlId.RespondReply, Desc.replyButtonDesc)
    .set(MailRibbonControlId.RespondReplyAll, Desc.replyAllButtonDesc)
    .set(MailRibbonControlId.RibbonCustomizer, Desc.customizeButtonDesc)
    .set(MailRibbonControlId.Rules, Desc.rulesButtonDesc)
    .set(MailRibbonControlId.SendDraft, Desc.sendDraftButtonDesc)
    .set(MailRibbonControlId.Sensitivity, Desc.sensitivityButtonDesc)
    .set(MailRibbonControlId.Sensitivity_LearnMore, Desc.sensitivityLearnMoreButtonDesc)
    .set(MailRibbonControlId.ShowLinkDialog, Desc.showLinkDialogButtonDesc)
    .set(MailRibbonControlId.AttachFile, Desc.attachFileButtonDesc)
    .set(MailRibbonControlId.AttachSig, Desc.attachSignatureButtonDesc)
    .set(MailRibbonControlId.Snooze, Desc.snoozeButtonDesc)
    .set(MailRibbonControlId.Sweep, Desc.sweepButtonDesc)
    .set(MailRibbonControlId.Table, Desc.tableButtonDesc)
    .set(MailRibbonControlId.ToolbarHighImportance, Desc.highImportanceButtonDesc)
    .set(MailRibbonControlId.ToolbarLowImportance, Desc.lowImportanceButtonDesc)
    .set(MailRibbonControlId.ToolbarNormalImportance, Desc.normalImportanceButtonDesc)
    .set(MailRibbonControlId.MoreRetentionPolicies, Desc.moreRetentionPoliciesButtonDesc)
    .set(MailRibbonControlId.Undo, Desc.undoButtonDesc);

export function getControlDescription(controlId: RibbonControlId): string | undefined {
    const description: string | undefined = controlDescMap.get(controlId);
    return description ? loc(description) : undefined;
}
